// utils/errorUtils.ts
import axios from "axios";

export const getErrorMessage = (error: unknown): string => {
	if (axios.isAxiosError(error)) {
		return (
			error.response?.data?.error?.message ||
			error.response?.data?.result?.error?.message ||
			error.message ||
			"Beklenmedik Bir Hata oluştu."
		);
	}

	if (error instanceof Error) {
		return error.message;
	}

	return "Beklenmedik Bir Hata oluştu.";
};

export const getBlobErrorMessage = async (error: unknown): Promise<string> => {
	if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
		try {
			const parsed = JSON.parse(await error.response.data.text());
			error.response.data = parsed;
		} catch {
			// body is not JSON; fall back to default handling
		}
	}

	return getErrorMessage(error);
};